import Util from "../../utils/helper";
import {
  CART_LIST_FAILED,
  CART_LIST_SUCCESS,
  CART_LIST_INVALID_REQUEST,
  CART_LIST_NOT_FOUND,
  LOADING_CART_LIST,
  RESET_CART_LIST,
  BUY_NOW_PRODUCT,
  RESET_BUYNOW_PRODUCT,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  carts: [],
  total: 0,
  isFromCart: true,
  steps: ["Order Details", "Shipping Address", "Checkout"],
  buyNowProduct: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CART_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case CART_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };
    case CART_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case CART_LIST_SUCCESS: {
      console.log("Card list PAYLOAD = ", action.payload);
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        carts: action.payload,
        total: Number(
          action.payload.reduce(
            (acc, { convertedOfferPrice, offerUnit, convertedProductPrice }) =>
              acc +
              +Util.discount(
                convertedProductPrice,
                convertedOfferPrice,
                offerUnit
              ),
            0
          )
        ).toFixed(1),
      };
    }

    case BUY_NOW_PRODUCT: {
      const {
        convertedOfferPrice,
        offerUnit,
        convertedProductPrice,
      } = action.payload;
      console.log("BUY NOW PAYLOAD = ", action.payload);
      return {
        ...state,
        total: Number(
          Util.discount(convertedProductPrice, convertedOfferPrice, offerUnit)
        ).toFixed(1),
        isFromCart: false,
        buyNowProduct: action.payload,
        steps: state.steps.filter((s) => s !== "Order Details"),
      };
    }

    case RESET_BUYNOW_PRODUCT: {
      return {
        ...state,
        isFromCart: true,
        steps: ["Order Details", "Shipping Address", "Checkout"],
        buyNowProduct: {},
        total: state.carts.length
          ? Number(
              state.carts.reduce(
                (
                  acc,
                  { convertedOfferPrice, offerUnit, convertedProductPrice }
                ) =>
                  acc +
                  +Util.discount(
                    convertedProductPrice,
                    convertedOfferPrice,
                    offerUnit
                  ),
                0
              )
            ).toFixed(1)
          : 0,
      };
    }

    case CART_LIST_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
        carts: [],
        total: 0,
        buyNowProduct: {},
      };

    case RESET_CART_LIST:
      return (state = initialState);

    default:
      return state;
  }
};
